<template>
    <div class="text-center">
        <v-dialog v-model="dialogVisible" persistent :width="Math.min($vuetify.breakpoint.width * 0.9, 1600)">
            <v-card class="not-margin pt-0 pr-0 pl-0">
                <v-toolbar dark color="primary">
                    <div class="text-center">
                    <v-icon>mdi-school</v-icon>
                    Formações de {{ nomeMes }} {{ ano }}
                    </div>
                </v-toolbar>
                <v-container fluid>
                    <v-form ref="form">
                        <v-row class="d-flex justify-center pl-0 mt-7">
                            <v-col cols="4">
                                <v-text-field
                                label="Formação"
                                v-model="form.filters.formacao"
                                outlined
                                dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <div class="text-center">
                            <v-col cols="12">
                                <sigfoco-tooltip
                                text="Buscar"
                                icon="mdi-magnify"
                                @click="buscarFormacoes"
                                ></sigfoco-tooltip>
                                <sigfoco-tooltip
                                text="Limpar"
                                icon="mdi-eraser"
                                @click="resetForm()"
                                ></sigfoco-tooltip>
                                <sigfoco-tooltip
                                text="Download Lista de Formações"
                                icon="mdi-download"
                                @click="baixarListaFormacao()"
                                ></sigfoco-tooltip>
                            </v-col>
                        </div>
                        <v-data-table
                            class="mt-5"
                            :headers="headers"
                            :items="form.lists.listFormacoesMes"
                            :items-per-page="10"
                            :footer-props="$footerProps"
                            >
                            <template v-slot:[`item.dataInicio`]="{ item }">
                                {{ $formatarData(item.dataInicio) }}
                            </template>
                            <template v-slot:[`item.dataFim`]="{ item }">
                                {{ $formatarData(item.dataFim) }}
                            </template>
                            <template v-slot:[`item.mes`]="{ item }">
                                {{ item.mes }}
                            </template>
                        </v-data-table>
                    </v-form>
                </v-container>
                <div class="btn-group text-center">
                    <v-btn color="primary" @click="fecharDialog">
                        Fechar
                    </v-btn>
                </div>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import pageLoadingMixin from "mixins/page-loading.mixin";
export default {
  name: "DialogFormacoesDoMes",
  mixins: [pageLoadingMixin],
  props: {
    visible: { type: Boolean, default: false },
    formacoes: { type: Array, default: () => [] },
    mes: { type: Number, default: null },
    ano: { type: Number, default: null }
  },
  
  data: () => ({
    form: {
      lists: {
        listFormacoesMes: []
      },
      filters: {
        formacao: null
      }
    },
    headers: [
      { text: "Item", align: "center", value: "item" },
      { text: "Data Início", align: "center", value: "dataInicio" },
      { text: "Data Final", align: "center", value: "dataFim" },
      { text: "Mês", align: "center", value: "mes" },
      { text: "Formação", align: "start", value: "formacao" },
      { text: "Local", align: "start", value: "local" }
    ]
  }),
  
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) this.$emit("onClose");
      }
    },
    nomeMes() {
      if (!this.mes) return "";
      const data = new Date(this.ano, this.mes - 1, 1);
      const mes = data.toLocaleDateString("pt-BR", { month: "long" });
      return mes.charAt(0).toUpperCase() + mes.slice(1);
    },
  },
  methods: {
    fecharDialog() {
      this.dialogVisible = false;
      this.form.filters.formacao = null;
      this.form.lists.listFormacoesMes = [];
    },
    buscarFormacoes() {
      this.showPageLoading();
      const params = {
        formacao: this.form.filters.formacao
      };
      this.$detalharCalendarioPaginaInicial(this.mes, this.ano, params)
        .then(({ data }) => {
          this.form.lists.listFormacoesMes = data?.resposta;
      this.hidePageLoading();
      });
    },
    resetForm() {
      this.form.filters.formacao = null;
      this.form.lists.listFormacoesMes = [];
    },
    baixarListaFormacao() {     
      this.showPageLoading();
      const params = this.$montarParamsFilters({ 
        ano: this.ano, 
        mes: this.mes,
        formacao: this.form.filters?.formacao
      });
      this.$downloadArquivosCalendarioPaginaInicial(this.mes, this.ano, params)
        .then(({ data }) => {
          const url = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Formacoes_${this.nomeMes}_${this.ano}.pdf`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          this.$notifySuccess("Operação realizada com sucesso!");
        })
        .catch(() => {
          this.$notifyError("Erro ao baixar o relatório de formações");
        })
        .finally(() => {
          this.hidePageLoading();
        }
      );
    }
  }
};
</script>